export default {
  "content": "<path d=\"M7 19.642V4.357a.2.2 0 01.305-.17l12.418 7.642a.2.2 0 010 .34L7.305 19.813a.2.2 0 01-.305-.17z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};